declare global {
  interface Window {
    __ENV?: Record<string, string | undefined>
  }
}

export const PUBLIC_ENV_KEY = '__ENV'

export function env(key: string): string | undefined {
  if (typeof window === 'undefined') {
    return process.env[key]
  }

  if (!key.startsWith('NEXT_PUBLIC_')) {
    throw new Error(
      `Environment variable '${key}' is not public and cannot be accessed in the browser.`,
    )
  }

  return window[PUBLIC_ENV_KEY]?.[key]
}
